export function toSafeCssUrl(raw: string): string | null {
	// prevent obscenely long URLs
	if (!raw || raw.length > 2048) { return null }

	try {
		const u = new URL(raw, window.location.origin)

		// allowlist schemes
		const ok = new Set(['https:', 'http:', 'data:', 'blob:'])
		if (!ok.has(u.protocol)) { return null }

		// block insecure HTTP URLs
		if (u.protocol === 'http:') { return null }

		// @FUTURE: allowlist hosts
		// const allowedHosts = new Set([window.location.host, "cdn.example.com"]);
		// if (u.protocol === "https:" && !allowedHosts.has(u.host)) return null;

		// reject SVGs
		if (u.protocol === 'data:') {
			const head = raw.slice(0, 64).toLowerCase()
			if (head.startsWith('data:image/svg+xml')) { return null }
		}

		// URL serialization percent-encodes spaces and quotes
		const href = u.toString()

		return `url("${href}")`
	} catch {
		return null
	}
}
